if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              // setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            // this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Select the node that will be observed for mutations
const rechargeDiv = document.getElementById('product-form-recharge');
var firstMutation = false;

let observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (!mutation.addedNodes) return;
    if (!firstMutation) {
      firstMutation = true;
      changeRCForm();
    } else {
      var rcIsChecked = document.querySelector("[data-radio-subsave]");
      if (rcIsChecked == undefined) return;

      var rcInformations = document.querySelector(".product__rc-informations");
      if (rcIsChecked.checked && rcInformations != undefined)
        rcInformations.style.display = "block";
      else
        rcInformations.style.display = "none";
    }

  })
})

if (rechargeDiv != undefined) {
  observer.observe(rechargeDiv, {
      childList: true
    , subtree: true
    , attributes: false
    , characterData: false
  })
}

// stop watching using:
// observer.disconnect()

function changeRCForm() {
  setTimeout(() => {
    updateDiscountLabel();
    moveInformations();
    allContainerClickable();
  }, 1000);
}

function updateDiscountLabel() {
  var labelsDiscount = document.querySelectorAll("[data-label-discount]");
    
  labelsDiscount.forEach((label) => {
    var oldLabel = label.innerHTML;
    label.innerHTML = oldLabel;
  });
}

function allContainerClickable() {
  var rcOption = document.querySelectorAll(".rc-option");

  rcOption.forEach((option) => {
    option.addEventListener("click", (el) => {
      if (document.querySelector(".product__scalapay-text") != undefined) {
        if (option.hasAttribute('data-option-subsave')) {
          document.querySelector(".product__scalapay-text").classList.add("not-active");
        } else {
          document.querySelector(".product__scalapay-text").classList.remove("not-active");
        }
      }
      var radioLabel = el.target.querySelector(".rc-radio__label");
      if (radioLabel != null && radioLabel != undefined) {
        radioLabel.click();
      }
    })
  })
}

function moveInformations() {
  // var sellingPlanLabel = document.querySelector(".rc-selling-plans__label");
  // var sellingPlanLabelContainer = document.querySelector("[data-rc-commitment]");

  // if (sellingPlanLabel != undefined && sellingPlanLabelContainer != undefined)
  //   sellingPlanLabelContainer.appendChild(sellingPlanLabel.childNodes[0]);

  // var rcPopup = document.querySelector(".rc_popup");
  // var rcPopupLabel = document.querySelector(".rc_popup__label");
  // var rcPopupContainer = document.querySelector("[data-rc-more]");
  
  // if (rcPopupLabel != undefined)
  //   rcPopupLabel.innerHTML = "En savoir +";

  // if (rcPopup != undefined && rcPopupContainer != undefined)
  //   rcPopupContainer.appendChild(rcPopup.childNodes[0]);

  var sellingPlanContainer = document.querySelector("[data-selector-subsave]");
  var rcInfos = document.querySelector("[data-rc-informations]");
  if (rcInfos != undefined && sellingPlanContainer != undefined)
    sellingPlanContainer.appendChild(rcInfos);
  if (document.querySelector("[data-label-text-subsave]") != undefined)
    document.querySelector("[data-label-text-subsave]").innerHTML = "Abonnement VIP";

}

var productTabs = document.querySelectorAll("[data-product-tab]");

productTabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    var position = tab.dataset.productTab;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 1024) {
      var container = document.querySelector("[data-product-tab-content='"+position+"'] .product__tabulation-content-child");
      var currentSvg = tab.querySelector("svg");
      var tabHeight = container.scrollHeight;
      if (container.clientHeight == tabHeight) {
        container.style.height = "0px";
        currentSvg.style.transform = "rotate(0deg)";
      } else {
        container.style.height = tabHeight + "px";
        currentSvg.style.transform = "rotate(180deg)";
      }
    } else {
      document.querySelector(".product__tabulation-title.tab--active").classList.remove("tab--active");
      document.querySelector(".product__tabulation-content.tab--active").classList.remove("tab--active");
  
      tab.classList.add("tab--active");
      document.querySelector("[data-product-tab-content='"+position+"']").classList.add("tab--active");
    }


  })
});